import { AlertTriangle, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import type { IdentityChangeDetail } from '@alamo/types';

export function IdentityChangeBanner({
  request,
}: {
  request: IdentityChangeDetail | null | undefined;
}) {
  const { t } = useTranslation('common');
  if (!request || ['completed', 'cancelled'].includes(request.status)) return null;
  return (
    <div
      role="alert"
      className="flex flex-wrap items-start gap-3 border-b border-sel-tint-laranja bg-laranja-encanto-04 px-4 py-3 sm:flex-nowrap sm:items-center"
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-laranja-encanto" aria-hidden="true" />
      <p className="min-w-0 flex-1 font-body text-sm leading-6 text-secondary-950">
        <strong className="block">{t('identity_change.banner_title')}</strong>
        {t(
          request.status === 'pending_review'
            ? 'identity_change.banner_review'
            : request.status === 'awaiting_signature'
              ? 'identity_change.banner_signature'
              : 'identity_change.banner_confirm',
        )}
      </p>
      <Link
        to="/migrate"
        className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-lg bg-alamo-surface px-3 font-body text-sm font-semibold text-azul-protecao hover:bg-sel-tint-laranja focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-azul-protecao sm:w-auto sm:shrink-0"
      >
        {t('identity_change.banner_action')}
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </div>
  );
}
